import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ShipmentChart from '../ShipmentChart/';

@inject('deliveryStore')
@observer
class ShipmentsStats extends Component {
  render() {
    const { deliveryStore } = this.props
    const { start, shipmentStats = {} } = deliveryStore;
    return <ShipmentChart date = {start} stats = {shipmentStats} onCollapse={this.props.onCollapse} />
  }
}

export default ShipmentsStats
